export default "__VITE_ASSET__Dsdeic9P__"